import React from 'react'
import { Form, Input } from 'antd';
import styles from './FieldInput.module.scss'

function FieldInput({ meta: { touched, error }, input, inputProps, tooltip, label, placeholder, type, disabled}) {
  return (
    <div className={styles.FieldInput}>
      <Form.Item
        style={{
          flexDirection: 'column',
          width: '100%',
          marginBottom: touched && error && 24 || 20,
        }}
        label={label}
        validateStatus={touched && error && "error" || null}
        help={touched && error || null}
        tooltip={tooltip && { 
          title: tooltip,
        }}
      >
        {type == 'password' ? <Input.Password
          {...input}
          placeholder={placeholder}
        /> : type == 'textarea' ? <Input.TextArea
        {...input}
        {...inputProps}
        placeholder={placeholder}
        disabled={disabled}
      /> : <Input
          {...input}
          disabled={disabled}
          placeholder={placeholder}
        />}
      </Form.Item>
    </div>
  )
}

export default FieldInput